import React from "react";
import Grid from "@mui/material/Grid2";
import SuiBox from "components/SuiBox";
import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import DashboardNavbar from "common/Navbars/DashboardNavbar";
import Footer from "common/Footer";
import AcreedoresTable from "./components/acreedoresTable";

const AcreedoresAdmin = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SuiBox>
        <Grid size={12}>
          <Grid xs={12}>
            <AcreedoresTable />
          </Grid>
        </Grid>
      </SuiBox>
      <Footer />
    </DashboardLayout>
  );
};

export default AcreedoresAdmin;
